const About = () => {
	return (
		<>
			<h1 className="display-3 mb-4">About</h1>
			<h2>Xeedo</h2>
			
		</>
	)
}
export default About